import { Content, ContentKind } from '@shared/domain/content/content.aggregate';
import { httpClient } from '@shared/infrastructure/http/http';
import { ContentDto, toContentDomainEntity } from './dto';
import { contentService } from '@shared/domain/content/content.service';
import { configuration } from 'configuration';

export const contentRepositoryImplementation = {
  getContents: async (
    countryCode: string,
    languageCode: string
  ): Promise<Content[]> => {
    const contents = await httpClient.get<ContentDto[]>(
      `${configuration.api.baseUrl}/api/${countryCode}/contents?supressgeneratethumbnailsastokens=1`,
      {
        'Accept-Language': languageCode
      }
    );
    return contents.map<Content>((content: ContentDto) =>
      contentService.createContent(toContentDomainEntity(content))
    );
  },

  updateContent: async (
    countryCode: string,
    languageCode: string,
    data: Content
  ): Promise<void> => {
    await httpClient.put(
      `${configuration.api.baseUrl}/api/${countryCode}/contents/${data.id}`,
      data || {},
      {
        'Accept-Language': languageCode
      }
    );
  },

  createContent: async (
    countryCode: string,
    languageCode: string,
    data: Content
  ): Promise<void> => {
    await httpClient.post(
      `${configuration.api.baseUrl}/api/${countryCode}/contents`,
      data || {},
      {
        'Accept-Language': languageCode
      }
    );
  },

  deleteContent: async (
    countryCode: string,
    contentId: number
  ): Promise<void> => {
    await httpClient.delete(
      `${configuration.api.baseUrl}/api/${countryCode}/contents/${contentId}`
    );
  },

  uploadFile: async (
    contentId: number,
    countryCode: string,
    body: any,
    fileType: ContentKind
  ): Promise<void> => {
    await httpClient.post(
      `${configuration.api.baseUrl}/api/${countryCode}/contents/${contentId}/file`,
      body,
      { 'Content-Type': getContentType(fileType)! }
    );
  }
};

function getContentType(fileType: string) {
  switch (fileType) {
    case 'Video':
      return 'video/mp4';
    case 'Game':
      throw new Error('No file upload allowed for content kind "Game".');
    case 'Document':
      return 'application/pdf';
  }
}
